import { take, put, call, all, takeLatest } from 'redux-saga/effects';
import moment from 'moment';

import {
  initMasterBrandInfo,
  requestMasterBrandStart,
  requestMasterBrandSuccess,
  requestAllMasterBrandSuccess,
  requestMasterBrandFail,

  postMasterBrandStart,
  postMasterBrandSuccess,
  postMasterBrandFail,

  patchMasterBrandStart,
  patchMasterBrandSuccess,

  deleteMasterBrandStart,
  deleteMasterBrandSuccess,
  deleteMasterBrandFail,

  requestDetailMasterBrandStart,
  requestDetailMasterBrandSuccess,
  requestDetailMasterBrandFail,

  putMasterBrandStart,
  putMasterBrandSuccess,
  putMasterBrandFail,

  deleteMultipleMasterBrandStart,
  deleteMultipleMasterBrandSuccess,
  deleteMultipleMasterBrandFail,

  patchMultipleMasterBrandStart,
  patchMultipleMasterBrandSuccess,
  patchMultipleMasterBrandFail,

  putMultipleMasterBrandStart,
  putMultipleMasterBrandSuccess,
  putMultipleMasterBrandFail,

  requestMasterBrandProductStart,
  requestMasterBrandProductSuccess,
  requestMasterBrandProductFail,

  postMasterBrandProductStart,
  postMasterBrandProductSuccess,
  postMasterBrandProductFail,

  postMultipleMasterBrandProductStart,
  postMultipleMasterBrandProductSuccess,
  postMultipleMasterBrandProductFail,

  deleteMasterBrandProductStart,
  deleteMasterBrandProductSuccess,
  deleteMasterBrandProductFail,

  importMasterBrandStart,
  importMasterBrandSuccess,
  importMasterBrandFail,

  requestImportMasterBrandStart,
  requestImportMasterBrandSuccess,
  requestImportMasterBrandFail,

} from '../actions/master-brand';

import requestManagement from '../service/requestManagement';
const { method_POST, method_GET, method_PUT, method_PATCH, method_DELETE, method_MULTIPLE_DELETE, method_MULTIPLE_PATCH, method_MULTIPLE_PUT, method_MULTIPLE_POST, method_IMPORT } = requestManagement;

import CONFIG from '@root/config/config.next';

const url = CONFIG.backendEndpoint;

export function* requestMasterBrand({ payload }) {

  /*console.log('[sages] requestMasterBrand : ', payload);*/

  const apiURL = `${url}/backend/v1/brand`;

  //====================================================================================================================

  try {
    const data = yield method_GET({
      url: apiURL,
      params: {
        "pagination[page]": payload.page === 0 ? 1 : payload.page,
        "pagination[limit]": payload.limit,
        "sort[field]": payload.field,
        "sort[order]": payload.order,
        "filter[status]": payload.status,
        "filter[q]": payload.q,
        "filter[parent]": payload.parent,
      }
    });

    /*console.log("[requestMasterBrand] GET : ", data);*/

    const { error } = data;

    if (Boolean(error)) {

      const { data: error_data } = error;

      /*console.log("[requestMasterBrand] GET : [error_data]", error_data);*/

      yield put(requestMasterBrandFail(error_data));
    }
    else {

      if (payload.limit === 'all') {
        yield put(requestAllMasterBrandSuccess(data));
      } else {
        yield put(requestMasterBrandSuccess(data));
      }
    }

  } catch (error) {
    yield put(requestMasterBrandFail(error));
  }

  //====================================================================================================================
}

export function* postMasterBrand({ payload }) {
  /*console.log('[sages] postMasterBrand : ', payload);*/
  const apiURL = `${url}/backend/v1/brand`;

  //====================================================================================================================

  try {
    const data = yield method_POST(
      {
        url: apiURL,
        data: payload.data
      }
    );

    /*console.log("[API] GET : ", data);*/

    yield put(postMasterBrandSuccess(data));

  } catch (error) {
    yield put(postMasterBrandFail(error));
  }

  //====================================================================================================================
}

export function* patchMasterBrand({ payload }) {
  /*console.log('[sages] patchMasterBrand : ', payload);*/
  const apiURL = `${url}/backend/v1/brand/${payload?.uuid}`;

  //====================================================================================================================

  try {
    const data = yield method_PATCH(
      {
        url: apiURL,
        data: payload?.data
      }
    );

    /*console.log("[API] GET : ", data);*/

    yield put(patchMasterBrandSuccess(data));

  } catch (error) {
    // yield put(patchMasterBrandFail(error));
  }

  //====================================================================================================================
}

export function* deleteMasterBrand({ payload }) {
  /*console.log('[sages] deleteMasterBrand : ', payload);*/
  const apiURL = `${url}/backend/v1/brand/${payload?.uuid}`;

  //====================================================================================================================

  try {
    const data = yield method_DELETE(
      {
        url: apiURL,
      }
    );

    /*console.log("[API] GET : ", data);*/

    yield put(deleteMasterBrandSuccess(data));

  } catch (error) {
    yield put(deleteMasterBrandFail(error));
  }

  //====================================================================================================================
}

export function* requestDetailMasterBrand({ payload }) {

  /*console.log('[sages] requestDetailMasterBrand : ', payload);*/

  const apiURL = `${url}/backend/v1/brand/${payload.uuid}`;

  //====================================================================================================================

  try {
    const data = yield method_GET({
      url: apiURL,
    });

    /*console.log("[API] GET : ", data);*/

    yield put(requestDetailMasterBrandSuccess(data));

  } catch (error) {
    yield put(requestDetailMasterBrandFail(error));
  }

  //====================================================================================================================
}

export function* putMasterBrand({ payload }) {
  /*console.log('[sages] putMasterBrand : ', payload);*/
  const apiURL = `${url}/backend/v1/brand/${payload.uuid}`;

  //====================================================================================================================

  try {
    const data = yield method_PUT(
      {
        url: apiURL,
        data: payload.data
      }
    );

    /*console.log("[API] GET : ", data);*/

    yield put(putMasterBrandSuccess(data));

  } catch (error) {
    yield put(putMasterBrandFail(error));
  }

  //====================================================================================================================
}

export function* deleteMultipleMasterBrand({ payload }) {
  /*console.log('[sages] deleteMultipleMasterBrand : ', payload);*/
  const apiURL = `${url}/backend/v1/brand`;

  //====================================================================================================================

  try {
    const data = yield method_MULTIPLE_DELETE(
      {
        url: apiURL,
        array: payload?.array
      }
    );

    /*console.log("[API] GET : ", data);*/

    yield put(deleteMultipleMasterBrandSuccess(data));

  } catch (error) {
    yield put(deleteMultipleMasterBrandFail(error));
  }

  //====================================================================================================================
}

export function* patchMultipleMasterBrand({ payload }) {
  /*console.log('[sages] patchMultipleMasterBrand : ', payload);*/
  const apiURL = `${url}/backend/v1/brand`;

  //====================================================================================================================

  try {
    const data = yield method_MULTIPLE_PATCH(
      {
        url: apiURL,
        array: payload?.array,
        data: payload?.data,
      }
    );

    /*console.log("[API] GET : ", data);*/

    yield put(patchMultipleMasterBrandSuccess(data));

  } catch (error) {
    yield put(patchMultipleMasterBrandFail(error));
  }

  //====================================================================================================================
}

export function* putMultipleMasterBrand({ payload }) {
  /*console.log('[sages] putMultipleMasterBrand : ', payload);*/
  const apiURL = `${url}/backend/v1/brand`;

  //====================================================================================================================

  try {
    const data = yield method_MULTIPLE_PUT(
      {
        url: apiURL,
        array: payload?.array,
        data: payload?.data,
      }
    );

    /*console.log("[API] GET : ", data);*/

    yield put(putMultipleMasterBrandSuccess(data));

  } catch (error) {
    yield put(putMultipleMasterBrandFail(error));
  }

  //====================================================================================================================
}

export function* requestMasterBrandProduct({ payload }) {

  /*console.log('[sages] requestMasterBrandProduct : ', payload);*/

  const apiURL = `${url}/backend/v1/brand/${payload.uuid}/map`;

  //====================================================================================================================

  try {
    const data = yield method_GET({
      url: apiURL,
      params: {
        "pagination[page]": payload.page === 0 ? 1 : payload.page,
        "pagination[limit]": payload.limit,
        "sort[field]": payload.field,
        "sort[order]": payload.order,
        "filter[status]": payload.status,
        "filter[q]": payload.q,
      }
    });

    /*console.log("[API] GET : ", data);*/

    yield put(requestMasterBrandProductSuccess(data));

  } catch (error) {
    yield put(requestMasterBrandProductFail(error));
  }

  //====================================================================================================================
}

export function* postMasterBrandProduct({ payload }) {
  /*console.log('[sages] postMasterBrandProduct : ', payload);*/
  const apiURL = `${url}/backend/v1/brand/${payload.uuid}/map`;

  //====================================================================================================================

  try {
    const data = yield method_POST(
      {
        url: apiURL,
        data: payload.data
      }
    );

    /*console.log("[API] GET : ", data);*/

    yield put(postMasterBrandProductSuccess(data));

  } catch (error) {
    yield put(postMasterBrandProductFail(error));
  }

  //====================================================================================================================
}

export function* postMultipleMasterBrandProduct({ payload }) {
  /*console.log('[sages] postMultipleMasterBrandProduct : ', payload);*/
  const apiURL = `${url}/backend/v1/brand`;

  //====================================================================================================================

  try {
    const data = yield method_MULTIPLE_POST(
      {
        url: apiURL,
        data: payload?.data,
        array: payload?.array,
      }
    );

    /*console.log("[API] GET : ", data);*/

    yield put(postMultipleMasterBrandProductSuccess(data));

  } catch (error) {
    yield put(postMultipleMasterBrandProductFail(error));
  }

  //====================================================================================================================
}

export function* deleteMasterBrandProduct({ payload }) {
  /*console.log('[sages] deleteMasterBrandProduct : ', payload);*/
  const apiURL = `${url}/backend/v1/brand/${payload.uuid}/map`;

  //====================================================================================================================

  try {
    const data = yield method_DELETE(
      {
        url: apiURL,
        data: payload.data
      }
    );

    /*console.log("[API] GET : ", data);*/

    yield put(deleteMasterBrandProductSuccess(data));

  } catch (error) {
    yield put(deleteMasterBrandProductFail(error));
  }

  //====================================================================================================================
}

export function* importMasterBrand({ payload }) {
  /*console.log('[sages] importMasterBrand : ', payload);*/
  const apiURL = `${url}/backend/v1/import/brand`;
  const formData = new FormData();
  formData.append('file', payload.file);
  //====================================================================================================================

  try {
    const data = yield method_IMPORT(
      {
        url: apiURL,
        data: formData
      }
    );

    /*console.log("[API] POST : ", data);*/

    yield put(importMasterBrandSuccess(data));

  } catch (error) {
    yield put(importMasterBrandFail(error));
  }

  //====================================================================================================================

}

export function* requestImportMasterBrand({ payload }) {

  /*console.log('[sages] requestImportMasterBrand : ', payload);*/

  const apiURL = `${url}/backend/v1/import/brand`;

  //====================================================================================================================

  try {
    const data = yield method_GET({
      url: apiURL,
      params: {
        "pagination[page]": payload.page === 0 ? 1 : payload.page,
        "pagination[limit]": payload.limit,
        "sort[field]": payload.field,
        "sort[order]": payload.order,
      }
    });

    /*console.log("[API] GET : ", data);*/

    yield put(requestImportMasterBrandSuccess(data));

  } catch (error) {
    yield put(requestImportMasterBrandFail(error));
  }

  //====================================================================================================================
}




export function* watchMasterBrand() {

  /*console.log('[sages] watchMasterBrand : ✅');*/

  yield all([
    takeLatest(requestMasterBrandStart, requestMasterBrand),
    takeLatest(postMasterBrandStart, postMasterBrand),
    takeLatest(patchMasterBrandStart, patchMasterBrand),
    takeLatest(deleteMasterBrandStart, deleteMasterBrand),
    takeLatest(requestDetailMasterBrandStart, requestDetailMasterBrand),
    takeLatest(putMasterBrandStart, putMasterBrand),
    takeLatest(deleteMultipleMasterBrandStart, deleteMultipleMasterBrand),
    takeLatest(patchMultipleMasterBrandStart, patchMultipleMasterBrand),
    takeLatest(putMultipleMasterBrandStart, putMultipleMasterBrand),
    takeLatest(requestMasterBrandProductStart, requestMasterBrandProduct),
    takeLatest(postMasterBrandProductStart, postMasterBrandProduct),
    takeLatest(postMultipleMasterBrandProductStart, postMultipleMasterBrandProduct),
    takeLatest(deleteMasterBrandProductStart, deleteMasterBrandProduct),
    takeLatest(importMasterBrandStart, importMasterBrand),
    takeLatest(requestImportMasterBrandStart, requestImportMasterBrand),
  ])
}



